import React from 'react';
import styles from './TopBar7.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar7 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        
        {/* Left Side: Contact Info */}
        <div className={styles.contactSection}>
          
          <div className={styles.infoBox}>
            <span className={styles.bracket}>[</span>
            <FaPhoneAlt className={styles.icon} />
            <span className={styles.text}>{phone}</span>
            <span className={styles.bracket}>]</span>
          </div>

          <div className={styles.infoBox}>
            <span className={styles.bracket}>[</span>
            <FaEnvelope className={styles.icon} />
            <span className={styles.text}>{email}</span>
            <span className={styles.bracket}>]</span>
          </div>

        </div>

        {/* Right Side: Social Tab */}
        <div className={styles.socialTab}>
          <div className={styles.tabContent}>
            
            <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.tabLink}>
              <FaFacebookF />
            </a>

            <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.tabLink}>
              <FaInstagram />
            </a>

            <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.tabLink}>
              <FaTwitter />
            </a>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar7;